module.exports = __webpack_public_path__ + "static/img/banner.8e22a545.jpg";